import request from '../../utils/request';

export interface IAgentQueryLog {
  id: number;
  token_id: number;
  tenant_id: number;
  email: string;
  token_label: string;
  sql: string;
  description: string;
  row_count: number;
  capped: boolean;
  duration_ms: number;
  executed_at: string;
  input_tokens: number | null;
  output_tokens: number | null;
}

export interface IAgentQueryLogResult {
  data: IAgentQueryLog[];
  count: number;
  page: number;
  limit: number;
}

class AgentQueryLogService {
  list = async (
    page = 1,
    limit = 50,
    tokenId?: number
  ): Promise<IAgentQueryLogResult> => {
    const params: Record<string, any> = { page, limit };
    if (tokenId != null) params.token_id = tokenId;
    const res = await request({ url: '/ai-chat/agent-query-log', method: 'GET', params });
    return res.data.body.data;
  };
}

export default new AgentQueryLogService();
